import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";
import SvgIcon from "../../../../parts/SvgIcon";

const id = "modal-select-macro-calculator";
const form = "select-macro-calculator";

const SelectMacroCalculator = ({
  workflow,
  explanationAdded,
  macroCalculators = [],
}) => {
  const { t } = useTranslation("coaching-portal");
  const [addVideo, setAddVideo] = useState(false);
  useEffect(() => {
    if (explanationAdded) {
      setAddVideo(false);
    }
  }, [explanationAdded]);

  if (!macroCalculators.length) {
    return (
      <Modal
        name={id}
        key={id}
        title={t("selectMacroCalculator.title")}
        className="getting-started-video"
      >
        <div className="body flex flex-col items-center justify-center pb-6">
          <p className="s2">{t("selectMacroCalculator.emptyTitle")}</p>
          <p className="p4 mt-4">
            {t("selectMacroCalculator.emptyDescription")}
          </p>

          <a
            href="/coaching-portal/widgets?section=learn&learn=macro-calculator"
            role="button"
            data-button-type="primary"
            className="mt-12"
          >
            {t("customWorkflows.createNew")}
          </a>
        </div>
      </Modal>
    );
  }

  return (
    <form
      action={
        addVideo
          ? "/actions/getting-started/video"
          : "/actions/getting-started/select-macro-calculator"
      }
      method="POST"
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      <input type="hidden" name="option" value="macroCalculator" />
      <input type="hidden" name="workflow" value={workflow._id} />

      <Modal
        name={id}
        key={id}
        title={t("selectMacroCalculator.title")}
        className="getting-started-video narrow"
        toClear={["explanationAdded"]}
      >
        <div className="body">
          {addVideo ? (
            <VideoUpload
              form={form}
              video={workflow.options.macroCalculator?.video}
              explanationVideo
              goBack={() => setAddVideo(false)}
            />
          ) : (
            <>
              <p className="p5 pb-2">
                {t("selectMacroCalculator.selectDescription")}
              </p>

              {macroCalculators.map(({ _id, name, description, icon }) => (
                <article
                  key={_id}
                  onClick={() => {
                    document.getElementById(_id)?.click();
                  }}
                >
                  <div className="flex items-center gap-3">
                    <SvgIcon src={`/img/widget-icons/${icon}.svg`} />
                    <div>
                      <p className="s2">{name}</p>
                      <p className="p5 mt-2">{description}</p>
                    </div>
                  </div>
                  <input
                    type="radio"
                    name="value"
                    id={_id}
                    value={_id}
                    defaultChecked={
                      workflow.options.macroCalculator?.widget === _id
                    }
                  />
                </article>
              ))}

              <div className="chip info mt-4">
                <span>
                  {t("selectMacroCalculator.toAddMore")}{" "}
                  <a href="/coaching-portal/widgets?section=learn&learn=macro-calculator">
                    {t("customWorkflows.clickHere")}
                  </a>{" "}
                  {t("customWorkflows.toVisitWidgetSection")}
                </span>
              </div>
            </>
          )}
        </div>

        <footer className="foot">
          {!addVideo && !explanationAdded && (
            <button
              onClick={() => setAddVideo(true)}
              type="button"
              data-button-type="outline"
              className="mr-auto"
            >
              <span>{t("customWorkflows.addExplanationVideo")}</span>
            </button>
          )}
          <button data-button-type="primary" type="submit">
            {addVideo ? t("customWorkflows.addVideoButton") : t("customWorkflows.selectButton")}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default SelectMacroCalculator;
